import { createI18n } from "vue-i18n"
import en from "./locales/en.json"
import ru from "./locales/ru.json"
import ar from "./locales/ar.json"
// Kept on disk for future use — not wired into the selector yet.
// import uz from "./locales/uz.json"
// import oz from "./locales/oz.json"

export type LocaleCode = "en" | "ru" | "ar"

export const SUPPORTED_LOCALES: ReadonlyArray<{
	code:     LocaleCode
	name:     string         // Native rendering: "English" / "Русский" / "العربية"
	englishName: string      // For aria-labels / fallback
	flag:     string         // Emoji — pure visual cue
	dir:      "ltr" | "rtl"
}> = [
	{ code: "en", name: "English",  englishName: "English", flag: "🇬🇧", dir: "ltr" },
	{ code: "ar", name: "العربية",  englishName: "Arabic",  flag: "🇦🇪", dir: "rtl" },
	{ code: "ru", name: "Русский",  englishName: "Russian", flag: "🇷🇺", dir: "ltr" },
]

const FALLBACK: LocaleCode = "en"

type MessageSchema = typeof en

const i18n = createI18n<[MessageSchema], LocaleCode>({
	locale:         FALLBACK,
	fallbackLocale: FALLBACK,
	legacy:         false,
	globalInjection:true,
	missingWarn:    import.meta.env.DEV,
	fallbackWarn:   import.meta.env.DEV,
	messages: { en, ru, ar },
	numberFormats: {
		en: {
			decimal: { style: "decimal", maximumFractionDigits: 2 },
			percent: { style: "percent", maximumFractionDigits: 0 },
		},
		ru: {
			decimal: { style: "decimal", maximumFractionDigits: 2 },
			percent: { style: "percent", maximumFractionDigits: 0 },
		},
		ar: {
			decimal: { style: "decimal", maximumFractionDigits: 2 },
			percent: { style: "percent", maximumFractionDigits: 0 },
		},
	},
	datetimeFormats: {
		en: {
			short: { year: "numeric", month: "short", day: "numeric" },
			long:  { year: "numeric", month: "long",  day: "numeric", hour: "2-digit", minute: "2-digit" },
		},
		ru: {
			short: { year: "numeric", month: "short", day: "numeric" },
			long:  { year: "numeric", month: "long",  day: "numeric", hour: "2-digit", minute: "2-digit" },
		},
		ar: {
			short: { year: "numeric", month: "short", day: "numeric" },
			long:  { year: "numeric", month: "long",  day: "numeric", hour: "2-digit", minute: "2-digit" },
		},
	},
	pluralRules: {
		ru: function (choice: number) {
			const mod10  = choice % 10
			const mod100 = choice % 100
			if (mod10 === 1 && mod100 !== 11) return 0
			if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 1
			return 2
		},
	},
})

export default i18n
